import {
  DashboardOutlined,
  UploadOutlined,
  FileImageOutlined,
} from "@ant-design/icons";

export const BASE_URL =
 "https://api.yogarefer.com/api" || process.env.REACT_APP_BASE_URL;
//"http://localhost:5001/api" || process.env.REACT_APP_BASE_URL;

export const adminMenu = [
  {
    key: "admin-dashboard",
    icon: <DashboardOutlined />,
    label: "Dashboard",
    path: "/dashboard",
  },

  {
    key: "all-users",
    icon: <UploadOutlined />,
    label: "Users",
    children: [
      { key: "users", label: "All Users", path: "/all-users" },
      { key: "add-user", label: "Add User", path: "/add-user" },
    ],
  },

  {
    key: "asana-upload",
    icon: <UploadOutlined />,
    label: "Asana Upload",
    children: [
      { key: "asanas", label: "All Asanas", path: "/all-asana" },
      { key: "create-asana", label: "Add Asana", path: "/asana-upload" },
    ],
  },

  {
    key: "Pages",
    icon: <UploadOutlined />,
    label: "Pages",
    children: [
      { key: "allpages", label: "Add Pages", path: "/allpages" },
      {
        key: "view-all-pages",
        label: "View All Pages",
        path: "/view-allpages",
      },

      {
        key: "how-to-make-variations",
        label: "How to Make Variations",
        children: [
          {
            key: "make-variations",
            label: "Make Variations",
            path: "/make-variations",
          },
          {
            key: "all-make-variations",
            label: "View Make Variations",
            path: "/all-make-variations",
          },
        ],
      },

      { key: "user-asana", label: "User Asanas", path: "/user-asana-approve" },
    ],
  },

 {
    key: "variation-poses",
    icon: <UploadOutlined />,
    label: "Variation Poses",
    children: [
      {
        key: "var-approval",
        label: "Variation Approval",
        path: "/var-approval",
      },
      {
        key: "media-link",
        label: "Media Link Approval",
        path: "/media-link",
      },
      {
        key: "expiry-report",
        label: "Expiring Extensions",
        path: "/expiry-report",
      },
      {
      key: "free-extension-approval",
      label: "Free Extensions",
      path: "/free-extension-approval",
    },
    {
  key: "follower-bonus-approval",
  label: "Follower Bonus",
  path: "/follower-bonus-approval",
},
{
  key: "error-report-approval",
  label: "Error Reports",
  path: "/error-report-approval",
},
    ],
  },
  {
    key: "global-images",
    icon: <DashboardOutlined />,
    label: "Global Images",
    path: "/overall-images",
  },
];

export const userMenu = [
  {
    key: "main-dashboard",
    icon: <DashboardOutlined />,
    label: "My Dashboard",
    path: "/main-dashboard",
  },
  {
    key: "upload-variation",
    icon: <UploadOutlined />,
    label: "Upload Variation",
    path: "/user-page",
  },
  {
    key: "my-variation",
    icon: <FileImageOutlined />,
    label: "My Variations",
    path: "/my-variation",
  },
  {
    key: "User-asana-upload",
    icon: <FileImageOutlined />,
    label: "Upload Asana",
    path: "/user-asana-upload",
  },
  {
  key: "my-asanas",
  icon: <FileImageOutlined />,
  label: "My Asanas",
  path: "/my-asanas",
},
  {
  key: "error-report",
  icon: <FileImageOutlined />,
  label: "Report an Error",
  path: "/error-report",
},
{
  key: "user-rules",
  icon: <FileImageOutlined />,
  label: "User Rules",
  path: "/user-rules",
}

];


